import { Observable } from 'rxjs';
import { YesNoDialogComponent, RteDialog } from 'rte-library';

export class DialogConfirmHelper{
    constructor(){}

    public static showConfirmDialog(dialog : RteDialog,description: string, title : string = 'Atenção') : Observable<any>{
        const dialogRef = dialog.customOpen(YesNoDialogComponent, {
            width: '45%',
            height: 'auto',
            data: { title, description }
        });

        return dialogRef.afterClosed();
    }
}
